{
  "de": {
    "validation": {
      "emailAddressDemo": "Die E-Mail-Adresse eines Kontakts in diesem Demo-Client muss auf '{email_address_suffix}' oder '{'@'}ziggu.io' enden",
      "emailTaken": "E-Mail-Adresse ist bereits vergeben",
      "errorsInLanguages": "Einige Übersetzungen enthalten Fehler, bitte prüfen: {languages}",
      "fix_errors": "Speichern fehlgeschlagen, bitte beheben Sie die Fehler",
      "import": {
        "inclusion": "Fehler in Zeile {rowNumber}, Spalte {columnNumber}: {headerName} ist nicht in der Liste enthalten",
        "inclusion_values": "mit zulässigen Werten: {values}",
        "invalid": "Fehler in Zeile {rowNumber}, Spalte {columnNumber}: {headerName} ist ungültig",
        "required": "Fehler in Zeile {rowNumber}, Spalte {columnNumber}: Ein Wert für {headerName} ist erforderlich",
        "unique": "Fehler in Zeile {rowNumber}: {headerName} ist nicht eindeutig, es gibt eine weitere Zeile mit diesem Wert"
      },
      "nameAlreadyTaken": "Name ist bereits vergeben",
      "needCompany": "Organisation ist erforderlich",
      "needName": "Name ist erforderlich"
    }
  }
}
